import { Client } from '@twilio/conversations'

import { TwilioConversationsMock } from '@lyrahealth-inc/shared-app-logic/src/features/messaging/twilioConversationsMock'

const conversationsClientMock = new TwilioConversationsMock()
;(window as any).conversationsClientMock = conversationsClientMock

class TwilioConversationsClientMock {
  constructor() {
    return conversationsClientMock
  }
}

export const TwilioConversations = window.Cypress ? TwilioConversationsClientMock : Client
